<template>
  <Dialog title="设备信息" :visible.sync="visible" :hasOperations="false">
    <div class="ac1000-device-info">
      <el-row :gutter="12">
        <el-col :span="12">
          <span class="label">网络类型</span>
          <span class="value">{{ model.netType === 1 ? 'WIFI' : '4G' }}</span>
          <el-button type="primary" size="mini" @click="resetNetworkType">重置</el-button>
        </el-col>
        <template v-for="(item, index) in options">
          <el-col :span="item.span" :key="index">
            <span class="label">{{ item.label }}</span>
            <span class="value">
              {{ item.format ? item.format(model[item.prop]) : model[item.prop] || '--' }}
            </span>
          </el-col>
        </template>
      </el-row>
      <div class="handler">
        <span @click="checkUpdate">{{ checkUpdateText }}</span>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from './Dialog.vue';
import { mapState } from 'vuex';
import { struct } from '@/utils/transform/index';
import { resetWifi, getDeviceStatus } from '@/api/deviceSetting';

export default {
  components: {
    Dialog
  },
  props: {
    sn: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      checkUpdateText: '检查更新',
      model: {
        netType: '',
        netState: '',
        filterUserTime: '',
        softwareVersion: '',
        hardwareVersion: ''
      },
      options: [
        {
          label: '网络状态',
          prop: 'netState',
          span: 12,
          format: v => (v === 1 ? '已连接' : '未连接')
        },
        { label: '滤芯状态', prop: 'filterUserTime', span: 24, format: v => `预期${v}个月` },
        { label: '软件版本', prop: 'softwareVersion', span: 12 },
        { label: '硬件版本', prop: 'hardwareVersion', span: 12 }
      ]
    };
  },
  computed: {
    ...mapState('socket', {
      deviceWs: 'singleDeviceDetail'
    })
  },
  watch: {
    deviceWs(n) {
      try {
        const ac1000Mod = n.mods.ac1000Mod;
        const res = struct(ac1000Mod, 'netState,netType,filterUserTime');
        Object.assign(this.model, res);
      } catch (e) {
        console.error(`[ac1000-WORKMODE]-更新model错误`, e);
      }
    }
  },
  methods: {
    setVersion(swVer, hwVer) {
      this.model.softwareVersion = swVer;
      this.model.hardwareVersion = hwVer;
    },
    checkUpdate() {
      this.checkUpdateText = '检测中...';
      getDeviceStatus({
        sn: this.sn,
        deviceType: this.deviceType
      })
        .then(res => {
          if (res && res.data && res.data.mainHwVer && res.data.mainSwVer) {
            this.setVersion(res.data.mainSwVer, res.data.mainHwVer);
          }

          this.$message.success('已更新');
        })
        .catch(err => {
          console.error('[ac1000-CHECK_UPDATE]:', err);
          this.$message.success('更新失败');
        })
        .finally(() => {
          this.checkUpdateText = '检测更新';
        });
    },
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    resetNetworkType() {
      resetWifi({
        sn: this.sn,
        deviceType: this.deviceType
      })
        .then(() => {
          this.$message.success('重置成功');
        })
        .catch(err => {
          console.error('[ac1000-RESET_NETWORK]: ', err);
          this.$message.warning('重置失败');
        });
    },
    updateModel(data) {
      Object.keys(this.model).forEach(key => {
        this.model[key] = data[key];
      });
    },
    mock() {
      this.updateModel({
        networkType: 'WIFI',
        networkState: '已连接',
        filterElementState: '预期24个月',
        softwareVersion: '1.0.0',
        hardwareVersion: '1.0.0'
      });
    }
  }
};
</script>

<style lang="scss">
.ac1000-device-info {
  color: #000;
  padding: 0 5.5em;

  .el-col {
    display: flex;
    align-items: center;

    &:nth-of-type(3) {
      margin: 2em 0;
    }

    .label {
      font-size: 2.25em;
      &::after {
        content: '：';
      }
    }

    .value {
      font-size: 2.25em;
      margin-right: 15px;
    }

    .el-button {
      font-size: 1.375em;
    }
  }

  .handler {
    margin-top: 2em;
    width: 100%;
    color: #3b89fb;

    font-size: 1.75em;

    display: flex;
    justify-content: center;

    span {
      cursor: pointer;
    }
  }
}
</style>
